import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { WindowEvents } from '@lsg/utils';
import { createElement, Component } from 'react';
import { Tabs } from '../Tabs/Tabs.js';

/**
 * This is a stateful version of `<Tabs>`.
 * The `<Tabs.Stateful>` variant is made for showcase purposes and non-React environments.
 * It should not be used in a React application. Please have a look at the section on "Stateful Components" in the
 * developer guidelines.
 * Check `<Tabs>` for implementation examples.
 */
var TabsStateful = /*#__PURE__*/function (_Component) {
  _inherits(TabsStateful, _Component);
  var _super = _createSuper(TabsStateful);
  function TabsStateful() {
    var _this;
    _classCallCheck(this, TabsStateful);
    _this = _super.apply(this, arguments);
    _this.state = {
      openIndex: _this.props.initialOpenIndex || 0,
      isMobile: ["sm", "xs"].includes(WindowEvents.getViewportSize())
    };
    _this.onViewportChange = function (viewportSize) {
      _this.setState({
        isMobile: ["sm", "xs"].includes(viewportSize)
      });
    };
    _this.handleChange = function (openIndex) {
      _this.setState({
        openIndex: openIndex
      });
    };
    return _this;
  }
  _createClass(TabsStateful, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      WindowEvents.addViewportCallback(this.onViewportChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      WindowEvents.removeViewportCallback(this.onViewportChange);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/createElement(Tabs, Object.assign({}, this.props, this.state, {
        onChange: this.handleChange
      }));
    }
  }]);
  return TabsStateful;
}(Component);
TabsStateful.displayName = "Tabs.Stateful";

export { TabsStateful };
